import http from '@/http'

export function update(data) {
  return http.put('/user', data)
}

export function log(params) {
  return http.get('/user/log', {
    params
  })
}

export function bill(params) {
  return http.get('/user/bill', {
    params
  })
}

export function ticket(params) {
  return http.get('/user/ticket', {
    params
  })
}